module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC3041-6ff7afe033fce341d8024e04378ac4b1.png";